module.exports = __webpack_public_path__ + "static/media/embed.f34eb2b1.svg";